import React, {  useState, useContext } from 'react';
import { CopyContext } from '../provider/MyProvider';
import './Faq.css';


export const Faq = () => {
    const [activeFaqs, setActiveFaqs] = useState([]);
    const { faqs } = useContext(CopyContext);

    // This function handles a click of an FAQ and makes it "active".  When "active" FAQ will expand to show the answer.  A second click will hide the answer once more.  "Active" questions are stored in an array so that mulitple answers can be shown at once.

    const handleFaqClick = (ques) => {
        if (!activeFaqs.includes(ques)) {
            setActiveFaqs([...activeFaqs, ques])
        } else {
            setActiveFaqs(activeFaqs.filter((f) => {
                return f.id !== ques.id
            }))
        };
    };
    
    // Rendering of FAQs - an "active" class is added to the elements when the question is clicked.  Using CSS, this will either show or hide the answer of the question.

    const renderQuestions = faqs.map((q) => {
        return (
            <div 
                className={"faq " + (activeFaqs.includes(q) ? "active" : "")}
                key={q.id} 
                value={q.id} 
                onClick={() => {handleFaqClick(q)}}
            >
                <h3 className={"faq-toggle " + (activeFaqs.includes(q) ? "active" : "")}>+</h3>
                <div className="faq-body">
                    <h4>{q.ques}</h4>
                    <div className="faq-ans" >
                        <p>{q.ans}</p>
                    </div>
                </div>
            </div>
        )
    });

  return (
    <section className="faq-container">
        
        <h1>FAQ</h1>
        
        <div className="ques-container">
            {renderQuestions}
        </div>
        
    </section>
  );
};